import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Document } from './document.model';
import { Interest } from './interest.model';
import { Partner } from './partner.model';

export type ActivityType = 'camping';
export enum ActivityTarget {
    kid = 'kid',
    adult = 'adult',
    teen = 'teen',
    all = 'all',
    water = 'water'
}
export interface ActivityExternalLink {
    name?: string;
    value?: string;
}

export enum ActivityUsableByType {
    User = 'user',
    Camping = 'camping'
}

@CwtModel({ name: 'activity', path: '/activity' })
export class Activity extends ApiData {
    partner?: Partner;
    name?: DictionaryObject;
    picture?: Document;
    pictures?: Document[];
    usableByTypes?: ActivityUsableByType;
    description?: DictionaryObject;
    type?: ActivityType;
    interests?: Interest[];
    target?: ActivityTarget;
    notationAverage?: number;
    notationCount?: number;
}
